import styled from 'styled-components'

const List = styled.div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin-right: 5px;
  }
`
export { List } // eslint-disable-line
